import { boolean, object, string } from 'yup';
import { useTranslation } from '../../../../../../../i18n/use-translation';

export function getSignatureValidation() {
  const { t } = useTranslation();

  return object().shape({
    phone: string()
        .matches(/^\+380[0-9]{9}$/is, t('phone_validation'))
        .required(t('requiredField')),
    password: string().required(t('requiredField')),
    termsAgreed: boolean().isTrue(t('requiredField')).required(t('requiredField')),
  });
}
